import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import HomePage from '../HomePage/HomePage';
import {
  popularcrowdsalepayload,
  livecrowdsalepayload,
  livecrowdfundpayload,
  finalizedcrowdsalepayload,
  finalizedcrowdfundpayload,
  successfulcrowdsalepayload,
  recommendcrowdsalepayload,
  recentcrowdsalepayload,
} from '../HomePage/crowdsaleparams';
import {
  finalizedCrowdfundStart,
  finalizedCrowdsaleStart,
  getLivePriceStart,
  liveCrowdfundStart,
  liveCrowdsaleStart,
  popularCrowdsaleStart,
  successfulCrowdsaleStart,
  recommendCrowdsaleStart,
  recentCrowdsaleStart,
} from '../../redux/crowdsale/Action';

const Home = ({ ual }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(popularCrowdsaleStart(popularcrowdsalepayload));
    dispatch(recommendCrowdsaleStart(recommendcrowdsalepayload));
    dispatch(liveCrowdsaleStart(livecrowdsalepayload));
    dispatch(liveCrowdfundStart(livecrowdfundpayload));
    dispatch(finalizedCrowdfundStart(finalizedcrowdfundpayload));
    dispatch(finalizedCrowdsaleStart(finalizedcrowdsalepayload));
    dispatch(successfulCrowdsaleStart(successfulcrowdsalepayload));
    dispatch(recentCrowdsaleStart(recentcrowdsalepayload));
    dispatch(getLivePriceStart({}));
  }, [dispatch]);

  return <HomePage ual={ual} />;
};
export default Home;
